























import {
  defineComponent, onMounted, ref, toRefs,
} from '@nuxtjs/composition-api';
import { Portal, PortalTarget } from 'portal-vue';
import { mixin as clickaway } from 'vue-clickaway';

import EGlobalIcons from '~/types/EGlobalIcons';

import Icons from '../szukaj/seo/types/seoIcons';
import getBody from './full-screen-mobile-modal/services/functions/getBody';
import icon from './icon.vue';

export default defineComponent({
  components: { icon, Portal, PortalTarget },
  mixins: [clickaway],
  props: {
    isFullScreen: {
      type: Boolean,
      default: false,
      required: false,
    },
    // Uzywamy tego aby Włączyć zagnieżdżanie kolejnego modala,
    // Wpisując nazwę "xyz" modal od razu ma tą funkcje
    // z tą opcją ten modal jest "Parentem"
    createNestName: {
      type: String,
      default: '',
      required: false,
    },
    // Tutaj mozemy wpisać w które miesjce ma zostać przeniesiony modal,
    // domyślnie idzie na sam początek layout'a
    // jeżeli zmieniami target to znaczy ze prawdopodobnie zagnieżdżamy modala w modalu
    portalTarget: {
      type: String,
      default: 'modal-placeholder',
      required: false,
    },
    cssRootClass: {
      type: String,
      default: () => '',
      required: false,
    },
  },
  setup(props, { emit, slots }) {
    const modalBodyExists = ref(false);
    const { portalTarget } = toRefs(props);
    const isNested = portalTarget.value !== 'modal-placeholder';
    const closeIconUrl = ref(EGlobalIcons.xLight);

    onMounted(() => {
      // eslint-disable-next-line dot-notation
      modalBodyExists.value = !!slots.default;
      if (!isNested) {
        getBody().classList.add('no-scroll');
      }
    });
    const close = () => {
      if (!isNested) {
        getBody().classList.remove('no-scroll');
      }

      emit('close');
    };

    return {
      closeIconUrl,
      close,
      modalBodyExists,
      Icons,
    };
  },
});
